var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoals(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.75 12H11V13.5H5.75V12ZM5.75 9H13.25V10.5H5.75V9ZM5.75 6H13.25V7.5H5.75V6ZM14.75 3H11.615C11.3 2.13 10.475 1.5 9.5 1.5C8.525 1.5 7.7 2.13 7.385 3H4.25C4.145 3 4.0475 3.0075 3.95 3.03C3.6575 3.09 3.395 3.24 3.1925 3.4425C3.0575 3.5775 2.945 3.7425 2.87 3.9225C2.795 4.095 2.75 4.29 2.75 4.5V15C2.75 15.2025 2.795 15.405 2.87 15.585C2.945 15.765 3.0575 15.9225 3.1925 16.065C3.395 16.2675 3.6575 16.4175 3.95 16.4775C4.0475 16.4925 4.145 16.5 4.25 16.5H14.75C15.575 16.5 16.25 15.825 16.25 15V4.5C16.25 3.675 15.575 3 14.75 3ZM9.5 2.8125C9.8075 2.8125 10.0625 3.0675 10.0625 3.375C10.0625 3.6825 9.8075 3.9375 9.5 3.9375C9.1925 3.9375 8.9375 3.6825 8.9375 3.375C8.9375 3.0675 9.1925 2.8125 9.5 2.8125ZM14.75 15H4.25V4.5H14.75V15Z",
    fill: "#E6E6E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoals);
export default __webpack_public_path__ + "static/media/goals.e7b2acdbf5ea1ce09ce5d4fbed2a0e83.svg";
export { ForwardRef as ReactComponent };